module.exports = __webpack_public_path__ + "tile.png";